import { Button } from "@/components/ui";

import { StepNote } from "./StepNote";

type Props = {
  suggested: string[];
  pickedPath: string | null;
  labelOf: (path: string) => string;
  onUse: (path: string) => void;
};

export function SecondCheck({ suggested, pickedPath, labelOf, onUse }: Props) {
  return (
    <>
      {suggested
        .filter((path) => path !== pickedPath)
        .map((path) => (
          <StepNote
            key={path}
            tone="warn"
            title={`May be the same fact as ${labelOf(path)}.`}
            body={`One AI said so on a second look. If it is, use ${labelOf(path)} so the seller answers once.`}
          >
            <Button size="sm" variant="outline" onClick={() => onUse(path)}>
              Use {labelOf(path)}
            </Button>
          </StepNote>
        ))}
    </>
  );
}
